import React, { useState } from 'react';
import { Typography, IconButton, Box, Divider } from '@mui/material';
import { ArrowRight, Delete, Edit } from '@mui/icons-material';
import { useDragOver } from '@minoru/react-dnd-treeview';
import PropTypes from 'prop-types';
import styles from './CustomNode.module.css';
import EditDialog from './EditDialog';
import DeleteConfirmationDialog from 'components/Management/DeleteConfirmationDialog';

const CustomNode = ({ data, options, organizationName, onDelete, handleEditGroup }) => {
    const { id, name, droppable, description, required } = data;
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [showDeleteConfirmationDialog, setShowDeleteConfirmationDialog] = useState(false);
    const indent = options.depth * 24;

    const handleToggle = (e) => {
        e.stopPropagation();
        options.onToggle(id);
    };

    const dragOverProps = useDragOver(id, options.isOpen, options.onToggle);

    const handleCloseDialog = () => {
        setShowEditDialog(false);
    };

    const handleCloseDeletionDialog = () => {
        setShowDeleteConfirmationDialog(false);
    };

    const handleSubmit = (data) => {
        setShowEditDialog(false);
        handleEditGroup(id, data);
    };

    return (
        <>
            <div className={`tree-node ${styles.root}`} style={{ paddingInlineStart: indent }} {...dragOverProps}>
                <div className={`${styles.expandIconWrapper} ${options.isOpen ? styles.isOpen : ''}`}>
                    {droppable && (
                        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
                        <span onClick={handleToggle}>
                            <ArrowRight />
                        </span>
                    )}
                </div>
                <div className={styles.labelGridItem}>
                    <Typography variant="body2" sx={{ color: '#000000' }}>
                        {description === '' || null ? name : `${name} - ${description}`}
                    </Typography>
                </div>
                {showEditDialog && <EditDialog data={data} onClose={handleCloseDialog} onSubmit={handleSubmit} />}
                {name !== organizationName && (
                    <Box sx={{ padding: '0 4px' }}>
                        <IconButton
                            size="small"
                            sx={{ float: 'right' }}
                            disabled={required}
                            onClick={() => setShowDeleteConfirmationDialog(true)}
                        >
                            <Delete fontSize="small" />
                        </IconButton>
                        <IconButton size="small" sx={{ float: 'right' }} disabled={required} onClick={() => setShowEditDialog(true)}>
                            <Edit fontSize="small" />
                        </IconButton>
                    </Box>
                )}
                {showDeleteConfirmationDialog && (
                    <DeleteConfirmationDialog onClose={handleCloseDeletionDialog} onYes={() => onDelete(id)} name="group" />
                )}
            </div>
            <Divider />
        </>
    );
};

CustomNode.propTypes = {
    data: PropTypes.object,
    options: PropTypes.object,
    organizationName: PropTypes.string,
    onDelete: PropTypes.func,
    handleEditGroup: PropTypes.func
};

export default CustomNode;
